import { useQuery } from '@tanstack/react-query';
import { occupancyService } from '../services/occupancyService';

export const OCCUPANCY_QUERY_KEY = 'occupancy';

/**
 * Fetches the occupancy summary for the current owner.
 * No parameters needed for the dashboard-level aggregate view.
 */
export const useOccupancy = () =>
  useQuery({
    queryKey: [OCCUPANCY_QUERY_KEY] as const,
    queryFn: () => occupancyService.getOccupancy(),
  });
